module.exports = __webpack_public_path__ + "img/alpaca.482515f0.jpeg";